import { RouteType } from '@/Routes';
import { lazy } from 'react';

const PasswordResetRequest = lazy(
  () => import('@/pages/password_reset/request/[type]')
);
const PasswordResetReset = lazy(
  () => import('@/pages/password_reset/reset/[type]')
);

const ServerPasswordReset: RouteType[] = [
  {
    path: '/password_reset/request/:type(user|affiliator|admin)',
    component: PasswordResetRequest,
    title: 'パスワードリセット',
  },
  {
    path: '/password_reset/reset/:type(user|affiliator|admin)',
    component: PasswordResetReset,
    title: 'パスワードリセット',
  },
];

export default ServerPasswordReset;
